// extracted by mini-css-extract-plugin
module.exports = {"slide":"styles_slide__3EUkh","isActive":"styles_isActive__33mHl","isNext":"styles_isNext__1wQ1w","isPrev":"styles_isPrev__2Vh5o"};